import * as React from 'react';
import InputMask from 'react-input-mask';
import TextField from '@mui/material/TextField';

export const TextMaskCC = React.forwardRef(function TextMaskCC(props: any, ref) {
  return (
    <InputMask
      mask="9999 9999 9999 9999"
      maskChar={null}
      {...props}
    >
      {(inputProps: any) => (
        <TextField
          {...inputProps}
          inputRef={ref}
          variant="outlined"
          fullWidth
        />
      )}
    </InputMask>
  );
});

export const TextMaskExpiry = React.forwardRef(function TextMaskExpiry(props: any, ref) {
  return (
    <InputMask
      mask="99/99"
      maskChar={null}
      {...props}
    >
      {(inputProps: any) => (
        <TextField
          {...inputProps}
          inputRef={ref}
          variant="outlined"
          fullWidth
        />
      )}
    </InputMask>
  );
});

export const TextMaskCVC = React.forwardRef(function TextMaskCVC(props: any, ref) {
  return (
    <InputMask
      mask="9999"
      maskChar={null}
      {...props}
    >
      {(inputProps: any) => (
        <TextField
          {...inputProps}
          inputRef={ref}
          variant="outlined"
          fullWidth
        />
      )}
    </InputMask>
  );
});
